import React, { useEffect, useState } from "react";
import { FiMaximize, FiMinimize } from "react-icons/fi";

// "Full Screen" toggle for test pages. Follows the browser's real state, so the
// label stays right when the user leaves full screen with Esc. The top navbar is
// hidden in full screen by App.js.
export default function FullscreenButton({ className = "", style }) {
  const [isFull, setIsFull] = useState(!!document.fullscreenElement);

  useEffect(() => {
    const update = () => setIsFull(!!document.fullscreenElement);
    document.addEventListener("fullscreenchange", update);
    return () => document.removeEventListener("fullscreenchange", update);
  }, []);

  if (!document.documentElement.requestFullscreen) return null; // e.g. iPhone Safari

  const toggle = async () => {
    try {
      if (document.fullscreenElement) await document.exitFullscreen();
      else await document.documentElement.requestFullscreen();
    } catch (e) {
      /* blocked by the browser — the test still works without it */
    }
  };

  return (
    <button
      type="button"
      onClick={toggle}
      className={className}
      title={isFull ? "Exit full screen" : "Full screen"}
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: "6px",
        padding: "6px 12px",
        borderRadius: "8px",
        border: "1px solid rgba(127, 127, 127, 0.45)",
        background: "transparent",
        color: "inherit",
        fontSize: "0.85rem",
        fontWeight: 600,
        cursor: "pointer",
        whiteSpace: "nowrap",
        ...style,
      }}
    >
      {isFull ? <FiMinimize /> : <FiMaximize />}
      {isFull ? "Exit Full Screen" : "Full Screen"}
    </button>
  );
}
